import React from 'react';
import CodeDiffLine from '~/components/CodeDiffLine';
import CodeDiffHeader from '~/components/CodeDiffHeader';

interface GlideProps {
  packageInfo: object;
  filePath: string;
}

const Glide: React.FunctionComponent<GlideProps> = props => {
  const { name, commitHash } = props.packageInfo;
  const { filePath = 'glide.lock' } = props;

  //split Podfile#L5
  const splittedSelectedFilePath = filePath.split('#L');
  const file = splittedSelectedFilePath[0];
  const lineNumber = splittedSelectedFilePath[1] || '';
  const nextLineNumber = isNaN(Number(lineNumber)) ? '' : Number(lineNumber) + 1;

  return (
    <div>
      <div className="grid bo--1 border-color--white-dark mt lh+">
        <CodeDiffHeader text={file} />
        <CodeDiffLine type="normal" text={'\u00B7\u00B7\u00B7'} />
        <CodeDiffLine type="highlight" lineNumber={lineNumber} text={` - name ${name}`} />
        <CodeDiffLine
          type="highlight"
          lineNumber={`${nextLineNumber}`}
          text={`\u00A0\u0020version ${commitHash}`}
        />
        <CodeDiffLine type="normal" text={'\u00B7\u00B7\u00B7'} />
      </div>
    </div>
  );
};

export default Glide;
